<template>
<div class="audit-vocs-ratio-chart-group">
  <ratio-chart
    v-for="data in dataGroup"
    v-if="data.dimensions.length === 2"
    :key="data.id"
    :data-config="data"
    :ratio-low="data.ratioLow"
    :unit-prop="unitProp"
    style="flex:1 0 100%;padding:10px 0"
  />
</div>
</template>

<script>
import BaseCompare from './BaseCompare'
import {mapGetters} from 'vuex'
import RatioChart from '../../../04Statistical-Analysis/01Photochemical/00VOCs/02Species-Ratio/RatioChart'

export default {
  name: 'VocsRatioChart',
  extends: BaseCompare,
  components: {RatioChart},
  props: {
    auditDataList: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    unitProp: 'stdUnit',
    dataGroup: Object.freeze([])
  }),
  computed: {
    valueProp: () => 'autoValue',
    ...mapGetters({
      specificFactors: 'Factor/specificFactors'
    }),
    ratioOpts () {
      let {filterFactorMap} = this
      return this.specificFactors.reduce((list, specificFactor) => {
        let {factorId} = specificFactor
        let factor = filterFactorMap[factorId]

        if (factor) {
          let {specificValueFactorId} = specificFactor
          let specificValueFactor = filterFactorMap[specificValueFactorId]

          if (specificValueFactor) {
            list.push({
              value: `${factorId}-${specificValueFactorId}`,
              label: `${factor.name}/${specificValueFactor.name}`,
              id1: factorId,
              id2: specificValueFactorId,
              ratioLow: specificFactor.specificValueLow
            })
          }
        }
        return list
      }, [])
    }
  },
  methods: {
    filterCurrentSiteDeviceFactors (siteDeviceFactors) {
      let siteDeviceFactorMap = siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        map[siteDeviceFactor.factorId] = siteDeviceFactor
        return map
      }, {})

      return this.specificFactors.reduce((list, specificFactor) => {
        let {factorId} = specificFactor
        let factor = siteDeviceFactorMap[factorId]

        if (factor) {
          let {specificValueFactorId} = specificFactor
          let specificValueFactor = siteDeviceFactorMap[specificValueFactorId]

          if (specificValueFactor) {
            list.push(factor, specificValueFactor)
          }
        }

        return list
      }, [])
    },
    getData () {

    },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    setDataGroup () {
      let [dataConfig] = this.dataList
      let dimensionMap = dataConfig.dimensions.reduce((map, dimension) => {
        map[dimension.id] = dimension
        return map
      }, {})
      let {dataTimes, seriesMap} = dataConfig

      this.dataGroup = Object.freeze(this.ratioOpts.map(ratioOpt => ({
        id: ratioOpt.value,
        name: ratioOpt.label,
        dataTimes,
        dimensions: [dimensionMap[ratioOpt.id1], dimensionMap[ratioOpt.id2]],
        ratioLow: ratioOpt.ratioLow,
        seriesMap
      })))
    }
  },
  watch: {
    auditDataList: {
      immediate: true,
      handler (auditDataList) {
        clearTimeout(this.setDataListTimer)
        this.setDataListTimer = setTimeout(() => {
          this.setDataList(auditDataList)
          this.setDataGroup()
        }, 0)
      }
    }
  }
}
</script>

<style lang="scss">
.audit-vocs-ratio-chart-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid rgb(228, 231, 237);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/VocsRatioChart.vue